export default __webpack_public_path__ + "static/media/resume_auto.2df9df6d.svg";